import { Component, OnInit, Input } from '@angular/core';
import { BASE_HREF, LINKS_EXTERNAL } from '../../../../core/utils/constants';
import * as AOS from 'aos';

@Component({
  selector: 'app-internal-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  @Input() textFooter!: string;
  @Input() imageFooter!: string;

  /**rutas externas a webs y servicios de Reus */
  readonly REUS_ACCESIBILIDAD: String = LINKS_EXTERNAL.REUS_ACCESIBILIDAD;
  readonly REUS_PRIVACIDAD: String = LINKS_EXTERNAL.REUS_PRIVACIDAD;
  readonly REUS_PRIVACIDAD_EAIA: String = LINKS_EXTERNAL.REUS_PRIVACIDAD_EAIA;
  readonly REUS_COOKIES: String = LINKS_EXTERNAL.REUS_COOKIES;
  readonly REUS_AVISO: String = LINKS_EXTERNAL.REUS_AVISO;
  readonly REUS_INFO_RGPD : string = LINKS_EXTERNAL.REUS_INFO_RGPD;
  readonly REUS_MAPA_WEB : string = LINKS_EXTERNAL.REUS_MAPA_WEB;
  
  readonly REUS : string = LINKS_EXTERNAL.REUS;
  readonly REUS_LOCALIZ : string = LINKS_EXTERNAL.REUS_LOCALIZ;
  readonly REUS_CORREO : string = LINKS_EXTERNAL.REUS_CORREO;
  readonly REUS_INSTAGRAM : string = LINKS_EXTERNAL.REUS_INSTAGRAM;
  readonly REUS_TWITTER : string = LINKS_EXTERNAL.REUS_TWITTER;
  readonly REUS_FACEBOOK : string = LINKS_EXTERNAL.REUS_FACEBOOK;
  readonly REUS_SEU: String = LINKS_EXTERNAL.REUS_SEU;
  readonly REUS_YOUTUBE: String = LINKS_EXTERNAL.REUS_YOUTUBE;
  readonly REUS_REDES: String = LINKS_EXTERNAL.REUS_REDES;


  /** Rutas a imagenes de footer Redes Sociales */
  readonly INSTAGRAM: String = BASE_HREF + '/assets/images/footer-instagram-w.svg';
  readonly FACEBOOK: String = BASE_HREF + '/assets/images/footer-facebook-w.svg';
  readonly REDX: String = BASE_HREF + '/assets/images/footer-x-w.svg';
  readonly XARXES: String = BASE_HREF + '/assets/images/footer-more-w.svg';
  readonly YOUTUBE: String = BASE_HREF + '/assets/images/footer-youtube-w.svg';


  /** Rutas a imagenes de footer organismos oficiales */
  readonly RGPDUE: String = BASE_HREF + '/assets/images/rpgdue.png';
  readonly AYUNT_REUS: String = BASE_HREF + '/assets/images/ajreus-footer-logo-ajuntament-de-reus.svg';

  constructor() { }

  ngOnInit() {
    AOS.init();
  }


}
